import React from 'react';

interface ArrowLeftProps {
  className?: string;
}

export const ArrowLeft = ({ className = '' }: ArrowLeftProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M11.2928 4.79284C11.6833 4.40235 12.3164 4.40242 12.7069 4.79284C13.0974 5.18337 13.0974 5.81638 12.7069 6.20691L7.41394 11.4999H18.9999C19.5521 11.4999 19.9998 11.9476 19.9999 12.4999C19.9999 13.0522 19.5522 13.4999 18.9999 13.4999H7.41394L12.7069 18.7928C13.0974 19.1834 13.0974 19.8164 12.7069 20.2069C12.3164 20.5974 11.6834 20.5974 11.2928 20.2069L4.29285 13.2069C4.26321 13.1773 4.23693 13.1454 4.21179 13.1132C4.19679 13.0939 4.18143 13.0749 4.16785 13.0546C4.12097 12.9844 4.08472 12.9094 4.0575 12.8319C4.05279 12.8185 4.047 12.8055 4.04285 12.7919C4.03018 12.7502 4.02164 12.7076 4.01453 12.6649C4.0056 12.6112 3.99988 12.5561 3.99988 12.4999C3.99989 12.4166 4.01098 12.336 4.03015 12.2587C4.03434 12.2418 4.03776 12.2246 4.04285 12.2079C4.04606 12.1973 4.05004 12.187 4.05359 12.1766C4.08109 12.0959 4.11914 12.0181 4.16785 11.9452C4.20448 11.8903 4.24638 11.8393 4.29285 11.7928L11.2928 4.79284Z"
      fill="var(--color-bg-secondary-alt)"
    />
  </svg>
);
